import React, { useState } from "react";

const Accordion = ({ datum }) => {
  const [active, setActive] = useState(false);
  return (
    <div className="faq__accordion-listItem">
      <header
        className="d-flex align-items-center justify-content-between"
        onClick={() => setActive(!active)}
      >
        <div className="header--left d-flex align-items-center">
          <span className={active ? "rotate drop-icon" : "drop-icon"}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z"
                fill="#0D0D0D"
              />
            </svg>
          </span>
          <h4>{datum.title}</h4>

          <span className="lessons--tag">
            {datum.lists.length} interactive lessons
          </span>
        </div>
        {active && (
          <button>
            Start{" "}
            <span>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M6 14H9" stroke="#FBFBFB" strokeLinecap="round" />
                <path
                  d="M7.5 12.5V15.5"
                  stroke="#FBFBFB"
                  strokeLinecap="round"
                />
                <ellipse
                  cx="17.6275"
                  cy="12.7001"
                  rx="0.7"
                  ry="0.70013"
                  fill="#FBFBFB"
                />
                <ellipse
                  cx="17.6277"
                  cy="15.5576"
                  rx="0.7"
                  ry="0.70013"
                  fill="#FBFBFB"
                />
                <ellipse
                  cx="16.2"
                  cy="14.1273"
                  rx="0.7"
                  ry="0.70013"
                  fill="#FBFBFB"
                />
                <ellipse
                  cx="19.0582"
                  cy="14.1273"
                  rx="0.7"
                  ry="0.70013"
                  fill="#FBFBFB"
                />
                <path
                  d="M10.8128 9C10.8128 9 10.109 6.98741 10.8128 6.18919C11.1326 5.82641 11.6375 5.85661 12.1369 6.03039C13.2462 6.41645 14.7767 7.24074 15.3001 6.18919V6.18919C15.5733 5.64034 15.4871 5 15.4871 5"
                  stroke="#FBFBFB"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                />
                <path
                  d="M17.0134 9.3H8.09669C7.10147 9.3 6.14651 9.69303 5.43962 10.3936L4.10928 11.712C2.66854 13.1398 2.6152 15.4514 3.98856 16.9441L4.72336 17.7428C5.858 18.9761 7.80442 18.9761 8.93906 17.7428C9.13105 17.5341 9.40164 17.4154 9.68519 17.4154H15.6152C15.8697 17.4154 16.1125 17.522 16.2849 17.7093C17.3675 18.886 19.2248 18.8861 20.3075 17.7093L21.086 16.8631C22.4195 15.4137 22.3845 13.174 21.0064 11.7669L19.6938 10.4267C18.9881 9.70609 18.022 9.3 17.0134 9.3Z"
                  stroke="#FBFBFB"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                />
              </svg>
            </span>{" "}
          </button>
        )}
      </header>
      <div
        className={
          active
            ? "faq__accordion--content is-visible"
            : "faq__accordion--content"
        }
      >
        {datum?.lists?.map((list) => {
          return (
            <div key={list.id} className="lessons">
              <div className="lessons--title d-flex align-items-center">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16.6644 8.75259C17.0771 9.11951 17.1143 9.75158 16.7474 10.1644L11.4141 16.1644C11.2243 16.3779 10.9523 16.5 10.6667 16.5C10.381 16.5 10.109 16.3779 9.91926 16.1644L7.25259 13.1644C6.88567 12.7516 6.92285 12.1195 7.33564 11.7526C7.74842 11.3857 8.38049 11.4229 8.74741 11.8356L10.6667 13.9948L15.2526 8.83564C15.6195 8.42285 16.2516 8.38567 16.6644 8.75259Z"
                      fill="#DCDCDC"
                    />
                  </svg>
                </span>
                <h6>{list.title}</h6>
              </div>
              <button
                className={
                  !list.status
                    ? "lessons--button lessons--locked"
                    : "lessons--unlocked"
                }
              >
                {!list.status ? "Locked " : ""}
                {!list.status && (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.99992 3.33335C11.373 3.33335 12.4999 4.46026 12.4999 5.83335V8.33335H7.49992V5.83335C7.49992 4.46026 8.62682 3.33335 9.99992 3.33335ZM14.1666 8.33335V5.83335C14.1666 3.53978 12.2935 1.66669 9.99992 1.66669C7.70635 1.66669 5.83325 3.53978 5.83325 5.83335V8.33335H4.99992C4.07944 8.33335 3.33325 9.07955 3.33325 10V16.6667C3.33325 17.5872 4.07945 18.3334 4.99992 18.3334H14.9999C15.9204 18.3334 16.6666 17.5872 16.6666 16.6667V10C16.6666 9.07955 15.9204 8.33335 14.9999 8.33335H14.1666ZM4.99992 10H14.9999V16.6667H4.99992V10Z"
                      fill="#C3C3C3"
                    />
                  </svg>
                )}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Accordion;
